import { render, staticRenderFns } from "./TaxTypeEntry.vue?vue&type=template&id=2f7328b9"
import script from "./TaxTypeEntry.vue?vue&type=script&lang=js"
export * from "./TaxTypeEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports